module.exports = __webpack_public_path__ + "media/question2_au.afea3ed7.mp3";